import { combineReducers } from '@reduxjs/toolkit';
import { databaseReducer, IDatabaseSlice } from './slice/database/database';
import { eventReducer, IEventSlice } from './slice/events/event';
import { IUserSessionSlice, userSessionReducer } from './slice/user/user';
import { formEventReducer, IFormEventSlice } from './slice/events/form-event';

export interface IRootReducer {
    user: IUserSessionSlice,
    database: IDatabaseSlice,
    event: IEventSlice,
    formEvent: IFormEventSlice
}

const rootReducer = combineReducers({
    // user: userSessionReducer,
    // database: databaseReducer,
    event: eventReducer,
    formEvent: formEventReducer
})

export type RootState = ReturnType<typeof rootReducer>
export default rootReducer